<div class="date-container">
    <mat-form-field
        appearance="fill"
        [dir]="'rtl'"
        class="date-field"
        [bsConfig]="bsConfigOb"
        #dp="bsDatepicker"
        bsDatepicker
        [(bsValue)]="datePickerValue"
        (bsValueChange)="bsDatePickerMonthValueChange($event, dp)"
        (onShown)="handler(dp)"
        [maxDate]="maxDate"
    >
        <mat-datepicker-toggle matPrefix></mat-datepicker-toggle>
        <span matPrefix class="divider"> </span>
        <span *ngIf="noDateSelected" class="all-days-text">
            {{ 'allMonths' | translate }}
        </span>
        <input matInput [hidden]="noDateSelected" type="text" [value]="selectedDate | async" readonly="true" />
    </mat-form-field>
</div>
